import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { ROLE_SETS } from "../../authorization/roles";
import "./resetComplete.css";

class PasswordResetComplete extends Component {
  get getPlatform() {
    const userAgent = window.navigator.userAgent;
    if ((/Android/i).test(userAgent)) {
      return 'android';
    }
    if ((/(iPhone)|(iPad)|(iPod)/i).test(userAgent)) {
      return 'ios';
    }
    return 'other';
  }

  get pastorsCompleteText() {
    return (
      <div>
        <h2 className="troubles-logging-in-form__header-2">
          You have successfully created a password for your SOW Evangelism account.
        </h2>
        <h2>Now you can log in to { this.loginLink() }</h2>
      </div>
    );
  }

  get nonPastorsCompleteText() {
    return (
      <div>
        <h2 className="troubles-logging-in-form__header-2">You have successfully reset you password.</h2>
        <h2>Please use your email address and new password to log in to { this.loginLink() }</h2>
      </div>
    );
  }

  redirectToStoreOnTimeout() {
    setTimeout(function () {
      }, 500);
    switch (this.getPlatform) {
      //todo: stubbed urls, should head to real application pages
      case 'android':
        window.location.assign("https://play.google.com/store/apps");
        break;
      case 'ios':
        window.location.assign("https://itunes.apple.com/us/genre/ios-entertainment/id6016");
        break;
      default:
        window.location.assign("/");
    }
  }

  mobileLink() {
    let link = '';
    switch (this.getPlatform) {
      //todo: stubbed app names
      case 'android':
        link = 'android_appname://';
        break;
      case 'ios':
        link = 'ios_appname://';
        break;
      default:
        link = 'https://play.google.com/store/apps';
    }
    return <a href={link} onClick={this.redirectToStoreOnTimeout.bind(this)}>SOW Evangelism&nbsp;Mobile&nbsp;app</a>;
  }

  isUserPastor() {
    return ROLE_SETS.pastors.includes(this.props.user.type) && this.props.isNewPassword;
  }

  webPortalLink() {
    return <Link to="/auth/login">Pastor's&nbsp;Web&nbsp;Portal</Link>;
  }

  loginLink() {
    switch (this.props.user.type) {
      case 'SeniorPastor':
      case 'Pastor':
        return <span>{this.mobileLink()} or {this.webPortalLink()}</span>;
      case 'Administrator':
      case 'Evangelist':
        return this.webPortalLink();
      default:
        return this.mobileLink();
    }
  }

  render () {
    return (
      <div>
        <h1>Password created!</h1>
        { this.isUserPastor() ? this.pastorsCompleteText : this.nonPastorsCompleteText }
      </div>
    );
  }
}

export default PasswordResetComplete;



// WEBPACK FOOTER //
// ./src/components/pages/reset_password/reset_complete.js